import React, { useEffect, useState } from 'react'
import 'rc-tooltip/assets/bootstrap_white.css'
import Tooltip from 'rc-tooltip'
import { Card } from '../../../components/Card'
import { CloseBtn } from '../../../components/CloseBtn'
import FormattedMessage from '../../../helpers/FormattedMessage'
import { schoolCloth } from '../../../setups/setups'
import styles from './Step3.module.scss'
import { TopSection } from '../../../components/TopSection'
import { Button } from 'src/components/Button'
import { useIntl } from 'react-intl'

interface IProps {
  nextStep: () => void
  setPage: (page: number) => void
}

export const Step3 = ({ nextStep, setPage }: IProps) => {
  const intl = useIntl()
  const [color, setColor] = useState(window.localStorage.getItem('Union-color') || '')
  const [isError, setIsError] = useState(false)

  const clothType = window.localStorage.getItem('Union-clothType') || ''

  useEffect(() => {
    window.localStorage.setItem('Union-step', '3')
  }, [])

  const setClothColor = (type: string) => {
    setIsError(false)
    setColor(type)
  }

  const back = () => {
    setPage(2)
  }

  const next = () => {
    if (color) {
      window.localStorage.setItem('Union-color', color)
      nextStep()
    } else {
      setIsError(true)
    }
  }

  return (
    <>
      <TopSection
        title="UnionClothes.topSection.create.title"
        description="UnionClothes.topSection.create.description"
        hideMobile
      />

      <div className={styles.Wrapper}>
        <div className={styles.ButtonWrapper}>
          <CloseBtn cancel={back} />
        </div>

        <div className={styles.CardDescription}>
          <h3><FormattedMessage id={`ClothType.${clothType}`}/></h3>
          <p>
            <FormattedMessage
              id="UnionClothes.stage2.subtitle"
              values={{ product: intl.formatMessage({ id: `ClothType.${clothType}` }) }}
            />
          </p>
        </div>

        <Card
          title={'SchoolShop.stage3.title'}
          description={'SchoolShop.stage3.description'}
        >
          <div className={styles.SelectColorWrapper}>
            <h2><FormattedMessage id={"SchoolShop.stage3.SelectColor"}/></h2>
            <div>{color && <FormattedMessage id={`Color.${color}`}/>}</div>
          </div>
          <div className={styles.ColorsWrapper}>
            {Object.keys(schoolCloth[clothType].colors).map((itemColor) => (
              <Tooltip
                placement="bottom"
                overlayInnerStyle={{ padding: '16px', marginTop: '-5px', color: '#3D3E43', fontSize: '14px', border: '1px solid #E9EAED', borderRadius: '4px' }}
                overlay={<FormattedMessage id={`Color.${itemColor}`}/>}
                key={itemColor}
              >
                <div className={`${styles.ColorContainer} ${color === itemColor && styles.Active} ${isError && styles.Error}`}>
                  <div
                    className={styles.Color}
                    style={{ backgroundColor: schoolCloth[clothType].colors[itemColor] }}
                    onClick={() => { setClothColor(itemColor) }}
                  />
                </div>
              </Tooltip>
            ))}
          </div>
          {isError &&
          <div className={styles.ErrorText}>
              <FormattedMessage id={'SchoolShop.stage3.error'} />
          </div>
          }
        </Card>
      </div>
        <Button
          center
          onClick={next}
          buttonColor
          buttonDescription="SchoolShop.stage2.button"
        />
    </>
  )
}
